<template>
  <div
    id="select-creative"
  >
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="text-center mt-3">
      <div class="d-flex justify-content-center flex-wrap text-center gap-3">
        <Button
          class="btn btn-color9 mb-3 mb-lg-0"
          @click="handleSelectCreative('list')"
        >
          {{ $t('existing_creatives') }}
        </Button>
        <div class="text-center">
          <Button
            class="btn btn-color10 mb-3 mb-lg-0"
            @click="handleSelectCreative('create')"
          >
            {{ $t('add_new_creative') }}
          </Button>
        </div>
      </div>
      <!-- CREATIVES LIST -->
      <div v-if="openList" class="mt-5 border border-dashed border-color10 p-5">
        <div class="pb-4 d-flex justify-content-center">
          <form class="default-form w-100" @submit.prevent="search">
            <input
              type="text"
              class="form-control form-control w-100"
              :placeholder="$t('name_or_layout')"
              v-model="filters.search"
              @keyup="search"
            />
          </form>
        </div>
        <div v-if="creatives.length === 0 && loader">
          <Loader
            :size="'big'"
          />
        </div>
        <div v-else-if="creatives.length === 0">
          <p>{{ $t('no_creatives_found') }}</p>
        </div>
        <div v-else>
          <div>
            <div
              class="d-flex creative-item py-3 flex-wrap align-items-center border-bottom border-dashed"
              :class="{
                selected: checkIfIsSelectedById(creative.id),
                inactive: creative.format === 'YOUTUBE' || creative.status !== 'ACTIVE'
              }"
              v-for="(creative, index) in creatives"
              :key="index"
              :id="`creative-${index}`"
              @click="handleClick(creative)"
            >
              <div class="col-lg-4">
                <img :src="creative.file" alt="" style="max-width: 100px;" />
              </div>
              <div class="col-lg-6 text-start">
                <p class="mb-0">{{ creative.name }}</p>
                <p class="mb-0">
                  {{ creative.format | formatCreativeFormat }} | <strong>{{ creative.layout }}</strong>
                  <strong v-if="creative.format === 'AUDIO'">{{ creative.duration }} {{ $t('seconds') }}</strong>
                </p>
              </div>
              <div class="col-lg-2">
                <Button type="button" class="btn btn-xs btn-color10" @click="handleEditCreative(creative)">
                  {{ $t('edit') }}
                </Button>
              </div>
              <!-- <div class="col-lg-2">
                <Button type="button" class="btn btn-xs btn-color10">
                  {{ checkIfIsSelectedById(creative.id) ? $t('selected2') : $t('select2') }}
                </Button>
              </div> -->
              <b-tooltip :target="`creative-${index}`" :title="$t('creative_has_error')" v-if="creative.format !== 'YOUTUBE' && creative.status !== 'ACTIVE'"></b-tooltip>
            </div>
          </div>
          <div class="py-3">
            <b-pagination
              class="custom-pagination"
              v-if="totalPages > 1"
              v-model="page"
              :total-rows="totalItems"
              :per-page="itemsPerPage"
              :loading="loader"
              @input="getCreatives"
              hide-goto-end-buttons
            />
          </div>
          <div class="text-center mt-3">
            <Button
              type="button"
              class="btn btn-color10"
              @click="selectCreative"
              :disabled="selectedCreatives.length === 0"
            >
              {{ $t('select2') }}
            </Button>
          </div>
        </div>
      </div><!-- CREATIVES LIST -->
      <!-- CREATE -->
      <div v-if="isNew" class="mt-5 border border-dashed border-color10 p-5">
        <UpsertCreativeForm
          :advertiserId="advertiserId"
          :format="format"
          :hidePreview="hidePreview"
          :show-cancel="true"
          @creative-created="reset"
          @upsert-creative-error="handleError"
          @format-selected="handleFormatSelected"
          @canceled="handleCanceled('')"
        />
      </div><!-- CREATE -->
      <!-- EDIT -->
      <div v-if="isEdit" class="mt-5 border border-dashed border-color10 p-5">
        <UpsertCreativeForm
          v-if="isEdit"
          :advertiserId="advertiserId"
          :creative="selectedCreative"
          :format="selectedCreative.format"
          @creative-updated="handleUpdated"
          @upsert-creative-error="handleError"
          @canceled="handleCanceled('list')"
        />
      </div><!-- EDIT -->
    </div>
  </div>
</template>

<script>

// import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import CreativesService from '@/modules/creatives/services/creatives-service'
// import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import UpsertCreativeForm from '@/components/creatives/UpsertCreativeForm'

export default {
  name: 'SelectCreative',
  props: ['advertiserId', 'format', 'isSingleSelect', 'layout', 'hidePreview'],
  components: {
    AlertWraper,
    Button,
    Loader,
    UpsertCreativeForm
  },
  data () {
    return {
      loader: false,
      creatives: [],
      content: null,
      content_type: 'error',
      filters: {
        search: ''
      },
      isEdit: false,
      page: 1,
      selectedCreative: '',
      selectedCreatives: [],
      selectedFormat: '',
      throttleSearch: null,
      isNew: false,
      openList: false,
      to: 9,
      totalItems: 0,
      totalPages: 0
    }
  },
  created () {
    this.getCreatives()
  },
  watch: {
    /**
     * Creative Format
     *
     * @param newVal
     * @param oldVal
     */
    format (newVal, oldVal) {
      if (newVal) this.getCreatives()
    },
    /**
     * advertiserId
     *
     * @param newVal
     * @param oldVal
     */
    advertiserId (newVal, oldVal) {
      if (newVal) this.getCreatives()
    }
  },
  computed: {
  },
  methods: {
    /**
     * Check if creative is selected
     */
    checkIfIsSelectedById (id) {
      const index = this.selectedCreatives.findIndex(item => {
        return id === item.id
      })
      return index >= 0
    },
    /**
     * Get creatives
     */
    async getCreatives () {
      if (!this.advertiserId) return
      this.loader = true
      try {
        const creatives = await CreativesService.getCreatives({
          advertiserId: this.advertiserId,
          format: this.format,
          page: this.page,
          search: this.filters.search,
          layout: this.layout,
          approved_status: this.format === 'YOUTUBE' ? 'PENDING_CREATION' : ''
        })
        this.totalItems = creatives.meta.total
        this.totalPages = creatives.meta.last_page
        this.itemsPerPage = creatives.meta.per_page
        this.from = creatives.meta.from
        this.to = creatives.meta.to
        this.creatives = creatives.data.filter(creative => {
          return creative.layout !== '301x301' // display layout 301x301 audio only
        })
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Handle canceled
     */
    handleCanceled (type) {
      if (!type) {
        this.isEdit = false
        this.isNew = false
        this.openList = false
      }
      this.handleSelectCreative(type)
    },
    /**
     * Handle click
     */
    handleClick (creative) {
      if (creative.format !== 'YOUTUBE' && creative.status !== 'ACTIVE') return
      if (this.isSingleSelect && this.selectedCreatives.length >= 1) return
      // Check if there already is selected
      const index = this.selectedCreatives.findIndex(item => {
        return creative.id === item.id
      })
      if (index < 0) {
        // If isnt selected, add to array
        this.selectedCreatives.push(Object.assign({}, creative))
      } else {
        // Remove from array if is selected
        this.selectedCreatives.splice(index, 1)
      }
    },
    handleEditCreative (creative) {
      this.selectedCreative = ''
      this.openList = false
      this.isEdit = true
      this.selectedCreative = creative
    },
    /**
     * Handle error
     */
    handleError (error) {
      this.content = parseErrorResponseToArray(error)
    },
    /**
     * Handle format selected
     */
    handleFormatSelected (format) {
      this.selectedFormat = format
    },
    handleSelectCreative (value) {
      if (value === 'list') {
        this.isEdit = false
        this.isNew = false
        this.openList = true
      }
      if (value === 'create') {
        this.isEdit = false
        this.openList = false
        this.isNew = true
      }
    },
    /**
     * Handle updated
     */
    handleUpdated (creative) {
      this.isEdit = false
      // this.localCreative = creative
      this.content = null
    },
    /**
     * Hidden
     */
    hidden () {
      this.creatives = []
      this.page = 1
      this.selectedCreatives = []
      this.selectedFormat = ''
      this.content = null
    },
    /**
     * Load more
     */
    loadMore () {
      this.page++
      this.getCreatives()
    },
    /**
     * Reset
     */
    reset () {
      this.creatives = []
      this.page = 1
      this.selectedCreatives = []
      this.selectedFormat = ''
      this.handleSelectCreative('list')
      this.getCreatives()
    },
    /**
     * Search creatives
     */
    search () {
      clearTimeout(this.throttleSearch)
      this.page = 1
      this.throttleSearch = setTimeout(this.searchCreatives, 500)
    },
    /**
     * Get creatives for search
     */
    searchCreatives () {
      this.creatives = []
      this.getCreatives()
    },
    /**
     * Select creative
     */
    selectCreative () {
      if (this.selectedCreatives.length === 0) return
      this.$emit('creative-selected', this.selectedCreatives)
      this.openList = false
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.creative-item:hover, .creative-item.selected {
  cursor: pointer;
  background: #eee;
}
.creative-item.inactive {
  background: #eee;
  opacity: 0.3;
}
</style>
